import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "configuration-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslationConfig = _resolveComponent("TranslationConfig")!
  const _component_SegmentListPreview = _resolveComponent("SegmentListPreview")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TranslationConfig, {
        modelValue: _ctx.translationConfig,
        "view-mode": true,
        documentType: _ctx.documentType,
        pageNamePrefix: _ctx.$t('archive.configurationPrefix')
      }, null, 8, ["modelValue", "documentType", "pageNamePrefix"])
    ]),
    _createVNode(_component_SegmentListPreview)
  ]))
}